<template>
  <img :src="propsStore.logo" class="relative -top-12 mx-auto" width="400px" />
  <div class="flex flex-row justify-center align-middle">
    <Card
      class="p-4 sm:basis-full md:basis-2/3 xl:basis-1/2 2xl:basis-1/3 rounded-xl"
      pt:root:class="bg-white/80! backdrop-blur-xl dark:bg-surface-800/90! border-surface-200! dark:border-surface-600! border!"
      :pt-options="{ mergeProps: false }"
    >
      <template #title>
        <div class="relative text-center -inset-y-12 -m-5">
          <span class="bg-primary-500 dark:bg-primary-400 inline-flex justify-center items-center rounded-full drop-shadow-xl p-4">
            <i class="pi pi-lock text-4xl text-white dark:text-surface-800"></i>
          </span>
        </div>
        <p class="text-center text-sm font-normal">Please provide your email address and we will send the associated username(s).</p>
      </template>
      <template #content>
        <IconField iconPosition="left" class="mb-6 text-2xl w-full">
          <InputIcon>
            <i class="pi pi-envelope relative -top-1"></i>
          </InputIcon>
          <InputText placeholder="Email" v-model="emailVal" type="text" class="w-full" v-on:keyup.enter="forgotUsername" />
        </IconField>
        <Button label="Send Username(s)" class="w-full text-2xl" raised @click="forgotUsername"></Button>
        <Button label="Cancel" class="w-full text-2xl" text raised @click="$emit('navigate', 'LOGIN')"></Button>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { usePropsStore } from "@/stores/props";

const emailVal = ref("");

const emit = defineEmits<{
  navigate: [to: "LOGIN" | "PASSWORD" | "USERNAME"];
}>();

interface Props {
  adminLogin: boolean;
}
const props = defineProps<Props>();
const authStore = useAuthStore();
const propsStore = usePropsStore();

const forgotUsername = (): void => {
  const data = new FormData();
  data.append("email", emailVal.value);

  const forgotUsernameString = props.adminLogin ? "/admin/forgotusername" : "/portal/forgotusername";
  authStore.sessionExpired = false;

  axios.post(forgotUsernameString, data).then((response) =>
    handleApiResponse(
      response,
      (data: any) => {
        success("Email Sent", "An email was sent if the email address is valid");
        emit("navigate", "LOGIN");
      },
      (errors: ApiError[]) => {
        error("File Error", errors[0].message);
      }
    )
  );
};
</script>
